import React from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table';

export class OverallTableRow extends React.Component {
  render() {
    const { columns } = this.props;
    return (
      <TableRow>
        {columns.map((item, index) =>
          <TableRowColumn key={index}>{item}</TableRowColumn>
        )}
      </TableRow>
    )
  }
}

export default class OverallTable extends React.Component {
  render() {
    const { title, headers, body } = this.props;
    return (
      <div className='overall-table'>
        <h3 className='overall-table-header'>{title}</h3>
        <Table>
          <TableHeader
            displaySelectAll={false}
            adjustForCheckbox={false}>
            <TableRow>
              {headers.map((item, index) =>
                <TableHeaderColumn key={index}><h4>{item}</h4></TableHeaderColumn>
              )}
            </TableRow>
          </TableHeader>
          <TableBody>
            {body.map((item, index) =>
              <OverallTableRow columns={item.columns} key={index}/>
            )}
          </TableBody>
        </Table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OverallTable.js